import {
  AdvancedMarker,
  CollisionBehavior,
  Pin
} from '@vis.gl/react-google-maps'
import { YesObject } from '@yes.technology/react-toolkit'
import { useCallback, useState } from 'react'
import { MarkerProps } from './MapContainer.types'
import { defaultStyles, hoveredStyles, openedStyles } from './MapMarker.styles'
import { validateAndParseCoordinates } from './utils/address'

const MapMarker = ({ object, onOpenMarker, isOpened }: MarkerProps) => {
  const [isHovered, setIsHovered] = useState(false)

  const coordinates = validateAndParseCoordinates(
    object?.address?.[0] as YesObject
  )

  const handleClick = useCallback(() => {
    onOpenMarker(object.uuid, coordinates as google.maps.LatLngLiteral)
  }, [object.uuid, coordinates, onOpenMarker])

  const getPinStyles = () => {
    if (isOpened) {
      return openedStyles
    }

    if (isHovered) {
      return hoveredStyles
    }
    return defaultStyles
  }

  if (!coordinates) return null

  return (
    <>
      <AdvancedMarker
        collisionBehavior={CollisionBehavior.REQUIRED}
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        position={coordinates}
        title={object.des}
        zIndex={isOpened ? 2 : 1}
      >
        <Pin {...getPinStyles()} />
      </AdvancedMarker>
    </>
  )
}

export default MapMarker
